import React from "react";
import { Link as RrdLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function Link({ to, ...props }) {
  const [, i18n] = useTranslation();
  const localTo = `/${i18n.language}${to === "/" ? "" : to}`;
  return <RrdLink to={localTo} {...props} />;
}
